let collapsibleContent = {
    init() {
        this.details = document.querySelectorAll('.collapsible-content-section .collapsible-content details');

        if (this.details.length) {
            for (const detail of this.details) {
                detail.onclick = this.clickHandler.bind(this);
            }
        }
    },

    clickHandler(e) {
        let details = [...this.details].filter(x => x != e.target.closest('details'));

        for (const detail of details) {
            detail.open = false;
        }
    }
}

document.addEventListener('DOMContentLoaded', function () {
    collapsibleContent.init();
});